import React from 'react';
import './MissionSection.css';

const MissionSection = () => {
  return (
    <div className="mission-section">
      <div className="mission-content">
        <h2>Our Mission</h2>
        <p>
          At Improving the Future, we are dedicated to empowering communities through
          innovative education and sustainable farming practices. Our goal is to inspire
          growth, foster resilience, empower sustainablity, and cultivate a brighter tomorrow for everyone.
        </p>
      </div>
    </div>
  );
};

export default MissionSection;
